export let TourAPIStrategy;
(function (TourAPIStrategy) {
  TourAPIStrategy["NAV_PERSONA_USER_BASED"] = "nav-persona-user-based";
  TourAPIStrategy["NAV_PERSONA_PORTAL_PLUS_USER_BASED"] = "nav-persona-portal-plus-user-based";
  TourAPIStrategy["ONBOARDING_TOURS_PORTAL_BASED"] = "onboarding-tours-portal-based";
})(TourAPIStrategy || (TourAPIStrategy = {}));